import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const FeatureToggle = union([
    literal("land_registry_order_register_enabled_in_development_env"),
    literal("valuation_tab"),
]);
export type TFeatureToggleCodec = typeof FeatureToggle;
